// @flow
export const XSMALL_SCREEN = 320;
export const SMALL_SCREEN = 544;
export const MEDIUM_SCREEN = 768;
export const LARGE_SCREEN = 1024;
export const XLARGE_SCREEN = 1200;
